import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Full URL: /admissions/:unitId/adminPortal/admissionCycles
//   (with optional `:cycleId/edit` child for deep-linking the edit overlay,
//   and `create` child for the create overlay).
// Child routes have no component — they only contribute params/path info so
// the parent listing stays mounted while the overlay is open.
// Renders inside AdminPortalShell (sidebar + content layout).
export default store => ({
  path: "admissionCycles",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/AdmissionCyclesPage"
    ).then(m => m.default)
  ),
  childRoutes: [{ path: ":cycleId/edit" }, { path: "create" }],
});
